'use strict';

module.exports = {
  DEFAULT_UTC_OFFSET: 0,
  EARTH_RADIUS: 6371,
  FLOATING_PRECISION: 2,
};
